<!-- Logo -->
<a *ngIf="hide !== 'mini'" class="brand-link"> <!-- mini logo for sidebar mini 50x50 pixels -->
	<img src="{{logo.html_mini}}" [alt]="logo.alt || title" class="brand-image img-circle elevation-3" style="opacity: .8">
      <span  class="brand-text font-weight-light">{{title}}</span>
</a>
<a *ngIf="hide === 'mini'" class="brand-link"> <!-- mini logo for sidebar mini 50x50 pixels -->
	<img src="{{logo.html_lg}}" height="150" width="350" [alt]="logo.alt || title" class="">
</a>
